import http from "./httpService";

const apiEndPoint = "/trades";

function cardTradeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

function tradeCompletionCheckUrl(id) {
  return `/trades/complete-status/${id}`;
}

function tradeApprovalCheckUrl(id) {
  return `/trades/approve-status/${id}`;
}

function bTradeCompletionCheckUrl(id) {
  return `/btrades/complete-status/${id}`;
}

function bTradeApprovalCheckUrl(id) {
  return `/btrades/approve-status/${id}`;
}

export function getCardTrades() {
  return http.get(apiEndPoint);
}

export function getCardTrade(cardTradeId) {
  return http.get(cardTradeUrl(cardTradeId));
}

export function saveCardTrade(cardTrade) {
  if (cardTrade._id) {
    const body = { ...cardTrade };
    delete body._id;
    return http.put(cardTradeUrl(cardTrade._id), body);
  }

  return http.post(apiEndPoint, cardTrade);
}

export function deleteCardTrade(cardTradeId) {
  return http.delete(cardTradeUrl(cardTradeId));
}

export function tradeCompletionStatus(cardTrade) {
  if (cardTrade._id) {
    const body = { ...cardTrade };
    delete body._id;
    return http.put(tradeCompletionCheckUrl(cardTrade._id), body);
  }
}

export function tradeApprovalStatus(cardTrade) {
  if (cardTrade._id) {
    const body = { ...cardTrade };
    delete body._id;
    return http.put(tradeApprovalCheckUrl(cardTrade._id), body);
  }
}

export function bTradeCompletionStatus(cardTrade) {
  if (cardTrade._id) {
    const body = { ...cardTrade };
    delete body._id;
    return http.put(bTradeCompletionCheckUrl(cardTrade._id), body);
  }
}

export function bTradeApprovalStatus(cardTrade) {
  if (cardTrade._id) {
    const body = { ...cardTrade };
    delete body._id;
    return http.put(bTradeApprovalCheckUrl(cardTrade._id), body);
  }
}
